<h2>{{data.formTitle}}</h2>
<div *ngFor="let answer of data.response.answers" style="margin-bottom: 16px">
  <h3 style="margin: 0; margin-bottom: 8px">{{getField(answer.field.id)}}</h3>
  <p style="margin: 0">{{getLabel(answer)}}</p>
</div>
